import "./Footer.css";

const Footer = () => {
  return (
    <div className="Footer">
      <div className="information">
        <p className="click">Help</p>
        <p className="click">About</p>
        <p className="click">Feedback</p>
        <p className="click">Terms and Policies</p>

        <p className="click">Careers</p>
        <p className="click">Investor Relations</p>
      </div>
      <p className="copyright">© 2022 BetterIMDb</p>
    </div>
  );
};

export default Footer;
